import React, { useEffect } from "react";
import useInput from "../../../hooks/useIndicatorInput";
import IsRequiredModule from "./IsRequiredModule";
import { restrictAlphabets } from "../../../../utils/Utils";
const StochRsiExitSetting = (props) => {
  const { indicator, updateIndicator, isLong,t } = props;
  const [exitLong, bindExitLong, setExitLong] = useInput(indicator.value3);
  const [exitShort, bindExitShort, setExitShort] = useInput(indicator.value2);
  const [periodLong, bindPeriodLong, setPeriodLong] = useInput(
    indicator.period_num,
    0
  );
  useEffect(() => {
    updateIndicator({
      ...indicator,
      value3: exitLong,
      value2: exitShort,
      period_num: periodLong,
    });
  }, [exitLong, exitShort,periodLong]);

  useEffect(() => {
    setExitLong(indicator.value3);
    setExitShort(indicator.value2);
    setPeriodLong(indicator.period_num);
  }, [indicator]);
  return (
    <div>
      {isLong ? (
        <>
          <h6>Long Strategy</h6>
        
          <div className="d-flex justify-content-between indicator-setting-form align-items-center ">
            <div><label className="indicator-setting-label">{t("Sell Stochastic RSI Level")}</label></div>
            <div> <input type="number" {...bindExitLong} className="input-bg-color form-control indicator-setting-input"  onKeyPress={(e) => {
                        restrictAlphabets(e);
                      }}/>
            </div>
          </div>
        </>
      ) : (
        <>
          <h6>Short Strategy</h6>
          <div className="d-flex justify-content-between indicator-setting-form align-items-center ">
            <div><label className="indicator-setting-label">{t("Buy Stochastic RSI Level")}</label></div>
            <div> <input type="number" {...bindExitShort} className="input-bg-color form-control indicator-setting-input"  onKeyPress={(e) => {
                        restrictAlphabets(e);
                      }}/>
            </div>
          </div>
          
        </>
      )}
      
      <div className="d-flex justify-content-between indicator-setting-form align-items-center mb-2 ">
            <div><label className="indicator-setting-label">{t("period")}</label></div>
            <div> <input type="number" {...bindPeriodLong} className="input-bg-color form-control indicator-setting-input"  onKeyPress={(e) => {
                        restrictAlphabets(e);
                      }}/>
            </div>
          </div>
      <IsRequiredModule indicator={indicator} updateIndicator={updateIndicator} t={t}></IsRequiredModule>
    </div>
  );
};

export default StochRsiExitSetting;
